import ArrowCircleLeftSharpIcon from "@mui/icons-material/ArrowCircleLeftSharp";
import CreditCardRoundedIcon from '@mui/icons-material/CreditCardRounded';
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BASE_URL, IMG_URL } from "../AdminComponent/BaseUrl";
import InnerHeader from "./InnerHeader";
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

const View = () => {
  const [order, setOrder] = useState([])
  const [cart, setCart] = useState([])
  const [orderstatus, setOrderStatus] = useState()
  const { orderid } = useParams()


  const [value, setValue] = useState({
    tracking_no: "",
    courier_name: ""

  })


  const onTypeChange = (e) => {
    setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }



  async function getOrderDetails() {
    const data = {
      order_id: orderid
    }
    axios.post(`${BASE_URL}/order_view`, data)
      .then((res) => {
        setOrder(res.data[0])
        setValue({
          tracking_no: res.data[0].tracking_no,
          courier_name: res.data[0].courier_comp
        })
      })
  }

  async function getcartdata() {

    const data = {
      order_id: orderid
    }

    axios.post(`${BASE_URL}/getcartData`, data)
      .then((res) => {
        console.log(res)

        setCart(res.data)


      })
  }

  useEffect(() => {
    getcartdata()
    getOrderDetails()
  }, [])


  const timestamp = order.order_date;
  const date = new Date(timestamp);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice();

  const formattedDate = `${day}-${month}-${year}`;


  const onhandleChange = (orderid) => {
    const data = {
      order_id: orderid,
      order_status: orderstatus
    }
    axios.post(`${BASE_URL}/order_status_update`, data)
      .then((res) => {
        alert("Status Changed")
        getOrderDetails()
      })
  }

  const handleChange = (e) => {
    setOrderStatus(e.target.value)

  }

  const handletracking = (e) => {
    e.preventDefault()

    const data = {
      tracking_no: value.tracking_no,
      courier_name: value.courier_name,
      order_id: orderid
    }

    axios.post(`${BASE_URL}/updatetrackingdetails`, data)
      .then((res) => {
        console.log(res.data)
        alert("Data Submitted")
      })
      .then((err) => {
        console.log(err)
      })


  }


  const totalcgst = cart.reduce((total, row) => total + Number(row.cgst), 0);
  const totalsgst = cart.reduce((total, row) => total + Number(row.sgst), 0);

  const totalgst = totalcgst + totalsgst;

  const finalamt = totalgst + Number(order.totalamt);



  return (
    <div className="container-fluid page-body-wrapper col-lg-10">
      <div className="main-panel">
        <InnerHeader />

        <div className="content-wrapper">


          <div className="row">

            <div className="col-lg-4">
              <div className="card" style={{ height: "250px" }}>
                <div className="card-head">
                  <div className="card-head-label">
                    <h4 className="card-head-title">Customer Details</h4>
                  </div>
                </div>

                <div className="card-body">
                  <ul className="list-stats" style={{ paddingLeft: "0", width: "200px" }}>
                    <li>
                      <span className="lable">Customer name:</span>
                      &nbsp;<span className="value"><b>{order.sfirstname} {order.slastname}</b></span>
                    </li>
                    <li className="w-200 py-1">
                      <span className="lable">Address:</span>
                      &nbsp; <span className="value"><b>{order.shipaddress},{order.shipcity}-{order.shippostcode}</b></span>
                    </li>
                    <li className="py-1">
                      <span className="lable">Mobile:</span>
                      &nbsp; <span className="value"><b>93264789</b></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card" style={{ height: "250px" }}>
                <div className="card-head">
                  <div className="card-head-label">
                    <h3
                      className="card-head-title"
                      style={{ fontSize: "1.1rem" }}
                    >
                      <DescriptionOutlinedIcon />  Order Details
                    </h3>
                  </div>
                </div>

                <div className="card-body">
                  <ul className="list-stats" style={{ paddingLeft: "0" }}>
                    <li className="py-1">
                      <span className="lable">Order No:</span>
                      &nbsp;<span className="value"><b>{order.orderno}</b></span>
                    </li>
                    <li className="py-1">
                      <span className="lable">Order Date:</span>
                      &nbsp; <span className="value"><b>{formattedDate}</b></span>
                    </li>
                    <li className="py-1">
                      <span className="lable">Order Amt:</span>
                      &nbsp; <span className="value"><b>₹{order.totalamt}</b></span>
                    </li>
                    <li className="py-1">
                      <span className="lable">Order Status:</span>
                      &nbsp; <span className="value"><b>93264789</b></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-lg-4">


              <div className="card" style={{ height: "250px" }}>
                <div className="card-head" style={{ padding: "20px 0.5625rem" }}>
                  <div className="card-head-label">
                    <h3
                      className="card-head-title"
                      style={{ fontSize: "1.1rem" }}
                    >
                      <CreditCardRoundedIcon /> Payment Information
                    </h3>
                  </div>
                </div>

                <div className="card-body">
                  <ul className="list-stats" style={{ paddingLeft: "0" }}>
                    <li className="py-1">
                      <span className="lable">Payment Status:</span>
                      &nbsp;
                      <span className="value">
                        <span className="badge badge-success">
                          {!order.pstatus ? "Unpaid" : "Paid"}
                        </span>
                      </span>
                    </li>
                    <li className="py-1">
                      <span className="lable">Payment mode:</span>
                      &nbsp;<span className="value"><b>{order.paymode}</b></span>
                    </li>
                    <li className="py-1">
                      <span className="lable">Transaction Id:</span>
                      &nbsp;<span className="value"><b>Wallet</b></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>


          <div className="row mt-4">


            <div className="col-lg-9">
              <form onSubmit={handletracking} className="row align-items-center">

                <div className="form-group col-lg-5">
                  <label htmlFor="courier_name">
                    Courier Name<span className="text-danger">*</span>

                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={value.courier_name}
                    onChange={onTypeChange}
                    name="courier_name"
                    placeholder="Enter courier name"
                  />
                </div>
                <div className="form-group col-lg-5">
                  <label htmlFor="tracking_no">
                    Tracking No<span className="text-danger">*</span>

                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={value.tracking_no}
                    onChange={onTypeChange}
                    name="tracking_no"
                    placeholder="Enter tracking number"
                  />
                </div>
                <div className="col-lg-2 mt-1">
                  <button type="submit" className="btn btn-primary">Submit</button>
                </div>

              </form>
              <div>
                <div className="card" style={{ height: "min-content" }}>
                  <div className="card-head">
                    <div className="card-head-label">
                      <h3
                        className="card-head-title"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {/* <Link to='/webapp/orders'>
                          <ArrowCircleLeftSharpIcon className="arrow" />
                        </Link> */}
                        #Order No : {order.orderno}{" "}
                      </h3>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive pt-3">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th className='text-center' >Sr.No</th>
                            <th className='text-center' >Product Image</th>
                            <th className='text-center' >Product Name</th>
                            <th className='text-center' >Price</th>
                            <th className='text-center' >Size</th>
                            <th className='text-center' >Quantity</th>
                            <th className='text-center' >Total</th>
                          </tr>

                        </thead>
                        <tbody>
                          {cart.map((item, index) => {
                            const ptotal = item.price * item.pqty
                            return (
                              <tr>
                                <td className='text-center'>{index + 1}</td>
                                <td className='text-center'>  <img style={{ width: "100px", height: "100px" }} src={`${IMG_URL}/productimg/` + item.image1} className="" alt="" /> </td>
                                <td className='text-center'>{item.pname}</td>
                                <td className='text-center'>₹{item.price}</td>
                                <td className='text-center'>xs</td>
                                <td className='text-center'>{item.pqty}</td>
                                <td className='text-center'>Rs .{ptotal}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <button className="btn btn-info">Print Invoice</button>
                    </div>

                  </div>
                </div>

              </div>
            </div>

            <div className="col-lg-3">

              <div className="card" style={{ height: "300px" }}>
                <div className="card-head">
                  <div className="card-head-label">
                    <h3
                      className="card-head-title"
                      style={{ fontSize: "1.1rem" }}
                    >
                      <InsertDriveFileOutlinedIcon /> Order Summary{" "}
                    </h3>
                  </div>
                </div>

                <div className="card-body">
                  <div className="cart-summary">
                    <ul style={{ paddingLeft: "0" }}>
                      <li>
                        <span className="label">Added On</span>
                        <span className="value">{formattedDate}</span>
                      </li>
                      <li>
                        <span className="label">Cart Total</span>
                        <span className="value">
                          <span className="currency-value" dir="ltr">
                            <span className="currency-symbol">₹{order.totalamt}</span>
                          </span>{" "}
                        </span>
                      </li>
                      <li>
                        <span className="label">Cgst</span>
                        <span className="value">
                          <span className="currency-value" dir="ltr">
                            <span className="currency-symbol">₹{totalcgst}</span>
                          </span>{" "}
                        </span>
                      </li>
                      <li>
                        <span className="label">Sgst</span>
                        <span className="value">
                          <span className="currency-value" dir="ltr">
                            <span className="currency-symbol">₹{totalsgst}</span>
                          </span>{" "}
                        </span>
                      </li>
                      <li className="highlighted">
                        <span className="label">Net Amount</span>
                        <span className="value">
                          <span className="currency-value" dir="ltr">
                            <span className="currency-symbol">₹{finalamt}</span>
                          </span>{" "}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="card mt-4" style={{ height: "300px" }}>
                <div className="card-head">
                  <div className="card-head-label">
                    <h3
                      className="card-head-title"
                      style={{ fontSize: "1.1rem" }}
                    >
                      <InsertDriveFileOutlinedIcon /> Order Status{" "}
                    </h3>
                  </div>
                </div>

                <div className="card-body">

                  <label>Select Order Status</label>

                  <select className="form-select mb-3 w-100" style={{ height: "40px", borderColor: "lightgrey" }} onChange={(e) => handleChange(e)} value={order.ostatus} aria-label=".form-select-lg example">

                    <option value="pending">Pending</option>
                    <option value="Confirm">Confirm</option>
                    <option value="Dispatched">Dispatched</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Cancelled">Cancelled</option>
                  </select>

                  <button className="btn btn-primary w-100" onClick={() => onhandleChange(order.id)}>Update</button>


                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default View;